import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Sync to DoorLoop:", -1)
const _hoisted_3 = { class: "flex flex-col gap-4 relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "13",
  viewBox: "0 0 22 13",
  width: "22",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m12.1 7.58333h-.55v-2.97916c0-.14964-.1231-.27084-.275-.27084h-.4668c-.1629 0-.3221.0474-.4575.13644l-.52701.34599c-.03006.0197-.05587.04505-.07598.07459-.0201.02954-.03409.06268-.04118.09755s-.00713.07077-.00012.10565c.00701.03489.02093.06807.04097.09765l.30522.4506c.02.0296.0458.05502.0758.07482s.0636.03358.099.04056.0719.00702.1073.00012c.0354-.00691.0691-.02061.0991-.04035l.0162-.01049v1.87687h-.55c-.15194 0-.275.1212-.275.27084v.54166c0 .14964.12306.27084.275.27084h2.2c.1519 0 .275-.1212.275-.27084v-.54166c0-.14964-.1231-.27084-.275-.27084zm8.8-7.58333h-19.8c-.607406 0-1.1.48513-1.1 1.08333v10.83337c0 .5982.492594 1.0833 1.1 1.0833h19.8c.6074 0 1.1-.4851 1.1-1.0833v-10.83337c0-.5982-.4926-1.08333-1.1-1.08333zm-19.25 11.375v-2.16667c1.21516 0 2.2.96997 2.2 2.16667zm0-7.58333v-2.16667h2.2c0 1.19674-.98484 2.16667-2.2 2.16667zm9.35 6.50003c-1.82256 0-3.3-1.69782-3.3-3.7917 0-2.09422 1.47744-3.79167 3.3-3.79167 1.8226 0 3.3 1.69745 3.3 3.79167 0 2.09456-1.4781 3.7917-3.3 3.7917zm9.35 1.0833h-2.2c0-1.1967.9848-2.16667 2.2-2.16667zm0-7.58333c-1.2152 0-2.2-.96993-2.2-2.16667h2.2z",
    fill: "#193b68"
  })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "px-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "18",
  viewBox: "0 0 14 18",
  width: "14",
  class: "ml-1 mr-1",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m13.7448 3.69141-3.5693-3.445316c-.164-.1582034-.38644-.246094-.61977-.246094h-.2224v4.5h4.66667v-.21445c0-.22149-.0911-.43594-.2552-.59414zm-5.57813 1.08984v-4.78125h-7.29167c-.484896 0-.875.376172-.875.84375v16.31245c0 .4676.390104.8438.875.8438h12.25c.4849 0 .875-.3762.875-.8438v-11.5312h-4.95833c-.48125 0-.875-.37969-.875-.84375zm-5.83334-2.25c0-.15539.13052-.28125.29167-.28125h2.91667c.16114 0 .29166.12586.29166.28125v.5625c0 .15539-.13052.28125-.29166.28125h-2.91667c-.16115 0-.29167-.12586-.29167-.28125zm0 2.8125v-.5625c0-.15539.13052-.28125.29167-.28125h2.91667c.16114 0 .29166.12586.29166.28125v.5625c0 .15539-.13052.28125-.29166.28125h-2.91667c-.16115 0-.29167-.12586-.29167-.28125zm5.25 9.27705v.848c0 .1553-.13052.2812-.29166.2812h-.58334c-.16114 0-.29166-.1259-.29166-.2812v-.854c-.41162-.0204-.81193-.1589-1.1437-.399-.14219-.103-.14948-.3083-.02078-.4268l.42838-.3941c.10099-.0928.2512-.097.36933-.0257.14109.0851.30114.1308.46739.1308h1.02484c.23698 0 .43021-.2081.43021-.4637 0-.2092-.13161-.3934-.31974-.4476l-1.64062-.4746c-.67776-.1961-1.15135-.8233-1.15135-1.5254 0-.86202.69453-1.56233 1.55567-1.58448v-.84797c0-.15539.13052-.28125.29167-.28125h.58333c.16115 0 .29167.12586.29167.28125v.85395c.41161.02039.81193.15855 1.1437.39902.14218.10301.14948.30832.02078.4268l-.42839.39408c-.10099.0928-.2512.097-.36932.0257-.14109-.0854-.30115-.1308-.4674-.1308h-1.02484c-.23698 0-.43021.2081-.43021.4637 0 .2092.13162.3934.31974.4476l1.64063.4746c.67776.1961 1.15135.8233 1.15135 1.5254 0 .8624-.69453 1.5623-1.55568 1.5845z",
    fill: "#193b68"
  })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "px-2 pb-2"
}

import { UiCard, UiLoader } from '@/ui-kit';
import { ref } from 'vue';
import { Nullable } from '@/utils';
import { useToast } from 'vue-toastification';
import DoorLoopPaymentBlock from './DoorLoopPaymentBlock.vue';
import DoorLoopVendorBillBlock from './DoorLoopVendorBillBlock.vue';

type Block = 'payment' | 'vendor-bill';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoorLoopPanel',
  setup(__props) {

const { success } = useToast();

const visibleBlock = ref<Nullable<Block>>(null);

function toggleBlock(block: Block) {
	visibleBlock.value =
		visibleBlock.value === block ? null : block;
}

function onSuccess(block: Block) {
	visibleBlock.value = null;
	const message =
		block === 'payment'
			? 'Payment was successfully submitted.'
			: 'Vendor bill was successfully created.';
	success(message);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiCard), { theme: "white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(UiCard), {
            theme: "white",
            contentClass: "p-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "font-bold transition hover:bg-gray-200 w-full p-2 flex justify-start gap-2 items-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleBlock('payment')))
              }, [
                _hoisted_4,
                _createTextVNode(" Submit payment ")
              ]),
              (visibleBlock.value === 'payment')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(DoorLoopPaymentBlock, {
                      onSuccess: _cache[1] || (_cache[1] = ($event: any) => (onSuccess('payment')))
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCard), {
            theme: "white",
            contentClass: "p-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "font-bold transition hover:bg-gray-200 w-full p-2 flex justify-start gap-2 items-center",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleBlock('vendor-bill')))
              }, [
                _hoisted_6,
                _createTextVNode(" Create vendor bill ")
              ]),
              (
							visibleBlock.value === 'vendor-bill'
						)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(DoorLoopVendorBillBlock, {
                      onSuccess: _cache[3] || (_cache[3] = ($event: any) => (
								onSuccess('vendor-bill')
							))
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})